import React from 'react';
import { Box, styled, SxProps, Theme, useTheme } from '@mui/material';

import Typography from '../../../Typography';

interface TimestampProps {
  containerSx?: SxProps<Theme>;
  name?: string;
  timestamp?: number;
}

const Timestamp: React.FC<TimestampProps> = ({
  containerSx = {},
  name,
  timestamp,
}) => {
  const theme = useTheme();

  if (!timestamp) {
    return null;
  }

  const formattedTime = new Intl.DateTimeFormat(undefined, {
    timeStyle: 'short',
  }).format(timestamp * 1000);

  return (
    <Box
      sx={{ alignItems: 'center', display: 'flex', gap: '4px', ...containerSx }}
    >
      {name && (
        <>
          <Typography color={theme.palette.colors.grey[600]} variant='font11'>
            {name}
          </Typography>
          <Dot />
        </>
      )}
      <Typography color={theme.palette.colors.grey[600]} variant='font11'>
        {formattedTime}
      </Typography>
    </Box>
  );
};

const Dot = styled('div')`
  height: 2px;
  width: 2px;
  border-radius: 50%;
  background-color: ${props => props.theme.palette.colors.grey[600]};
`;

export default Timestamp;
